import {IMessage} from "./PA.Core.IF.Basic";


export enum AuditLogType {
  Info = "Info",
  Warning = "Warning",
  Error = "Error",

  CreateNew = "Create",
  Delete = "Delete",
  Change = "Change",
  Copy = "Copy",

  BaselineAccepted = "BaselineAccepted"
}

export interface AuditLogOptions {
  WB_SecondaryReference_Id?: number,
  SecondaryReference_Id?: string,
  Reference_Amt?: number,
  Source_Id?: string,
  Source_Integration_Id?: string,
  WB_Cust_Id?: number,
  WB_PrdGrp_Id?: number,
  PreviousValue?: string,
  NewValue?: string,
  WB_AUTHUSR_ID?:number
  Time?: Date
}

export interface IAuditService {

  setReference(WB_ReferenceType_ID: string, WB_Reference_ID: number): void
  /** Sets the reference to the WB_Job_Process  record for audit entries created by a job process */
  setJobProcess(WB_JobProcess_ID: number): void
  /** Sets the reference to the WB_Job_Process_Queue record for audit entries referencing a queue item */
  setQueueRecord(WB_Job_Process_Queue_ID: number): void
  Log(sType: AuditLogType, sMessage: string, options?: AuditLogOptions): Promise<void>
  LogSync(sType: AuditLogType, pMessage: string, pOptions?: AuditLogOptions): void
  LogMsgSync(msg: IMessage, pOptions?: AuditLogOptions): void
  Save(bUseBatch?: boolean): Promise<void>

}

